<template>
  <v-container fluid grid-list-md>
    <v-card style="padding: 16px" class="mx-auto">
      <v-card-text class="headline font-weight-bold">
        <v-card-actions class="headline font-weight-bold">
          <div>
            <h3>Pagamentos</h3>
          </div>
          <v-spacer></v-spacer>
        </v-card-actions>
        <div style="font-size: 16px; font-weight: 400">
          <i>Utilize os Filtros para melhorar a sua busca.</i>
        </div>
        <v-layout align-center justify-end>
          <v-btn fab top right small @click="enableFilters">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <export />
        </v-layout>
      </v-card-text>
    </v-card>
    <partner-payments />
    <filters />
    <v-btn color="indigo darken-2" dark @click.stop="goTo('partner')">
      Voltar
    </v-btn>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Partner-Payments",
  created() {
    this.$store.dispatch("partners_payments/load", this.$route.params.id);
  },
  components: {
    PartnerPayments: () =>
      import("@/components/partners-payments/PartnerPayments.vue"),
    Filters: () => import("@/components/partners-payments/Filters.vue"),
    Export: () => import("@/components/partners-payments/Export.vue"),
  },
  computed: {
    ...mapGetters({
      payments: "partners_payments/partnerPayments",
      filters: "partners_payments/filterParams",
      filtersExport: "partners_payments/filterExportReport",
      subtotal: "partners_payments/subtotal",
    }),
  },
  methods: {
    enableFilters() {
      this.$store.dispatch("partners_payments/showFilters", true);
    },
    goTo(route) {
      this.$router.push({ name: route });
      this.hideNavigation();
    },
  },
};
</script>
